import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Location } from '@angular/common';
import { NetworkService } from 'src/app/core/network-connection/network.service';
import { isPlatformBrowser } from '@angular/common';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-lost-network-connection',
  templateUrl: './lost-network-connection.component.html',
  styleUrls: ['./lost-network-connection.component.scss']
})
export class LostNetworkConnectionComponent implements OnInit, OnDestroy {

  showNetworkPageFound: boolean = false;

  constructor(
    private loc: Location,
    private network: NetworkService,
    @Inject(PLATFORM_ID) private platformId: object,
    private navigationService: NavigationService
  ) { }

  ngOnInit() {
    this.network.isActive = true;
    if (isPlatformBrowser(this.platformId)) {
      this.showNetworkPageFound = true;
    }
  }

  reload() {
    if (window.navigator.onLine) {
      this.navigationService.navigateByUrl(this.loc.path(true));
    }
  }

  ngOnDestroy(): void {
    this.network.isActive = false;
  }
}
